import { create } from "zustand";
import { api } from "~/lib/api";
import type { Product } from "~/types";

interface ProductsState {
  products: Product[];
  loaded: boolean;
  loading: boolean;
  load: () => Promise<void>;
  byId: (id: string) => Product | undefined;
}

export const useProductsStore = create<ProductsState>((set, get) => ({
  products: [],
  loaded: false,
  loading: false,
  load: async () => {
    if (get().loaded || get().loading) return;
    set({ loading: true });
    const products = await api.products();
    set({ products, loaded: true, loading: false });
  },
  byId: (id) => get().products.find((p) => p.id === id),
}));
